import React from "react";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {Input, Button, Checkbox, Form, Typography, message} from "antd";
import {Row, Col} from "antd";
import {withRouter} from "react-router-dom";
import Backend from "../Basics/Backend";
import googleAuthClient from "../auth";

const {Title, Text} = Typography;


class NormalLoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
        };
    }

    performLogin = (e) => {
        e.preventDefault();
        const response = googleAuthClient.requestCode("a");
    };

    onFinishFailed = (errorInfo) => {
        // console.log("Failed:", errorInfo);
    };

    checkChanged = () => {
        this.setState({checked: !this.state.checked});
    };

    render() {
        return (
            <div>
                <Row>
                    <Col xs={4} sm={4} md={6} lg={8} xl={8}></Col>
                    <Col xs={16} sm={16} md={12} lg={8} xl={8}>
                        <div className="login-general">
                            <div className="login-welcome">
                                <Title>Ingreso a UAPApp</Title>
                                <Text>
                                    Para continuar, por favor escriba su usuario y contraseña.
                                </Text>
                            </div>
                            <Button onClick={this.performLogin} type="primary" htmlType="submit" className="login-form-button">
                                Ingresar
                            </Button>
                        </div>
                    </Col>
                    <Col xs={4} sm={4} md={6} lg={8} xl={8}></Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(NormalLoginForm);
